import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const ArtikelbezeichnungsgeneratorBausteineServiceConfig = {
  name: "ArtikelbezeichnungsgeneratorBausteine",
  annotations: []
} as ServiceConfig;